import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.624.967A.67.67 0 0 1 4.158.7h8c.21 0 .407.099.533.267l2 2.666a.67.67 0 0 1 .133.4v9.334a2 2 0 0 1-2 2H3.491a2 2 0 0 1-2-2V4.033c0-.144.047-.284.133-.4zm.867 1.066L2.824 4.256v9.11a.667.667 0 0 0 .667.667h9.333a.667.667 0 0 0 .667-.666V4.256l-1.667-2.223z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.491 6.033c.368 0 .667.299.667.667a2 2 0 1 0 4 0 .667.667 0 0 1 1.333 0 3.333 3.333 0 0 1-6.667 0c0-.368.299-.667.667-.667M1.491 4.033c0-.368.298-.666.667-.666h12a.667.667 0 0 1 0 1.333h-12a.667.667 0 0 1-.667-.667",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })